module.exports = __webpack_public_path__ + "img/bares.bbcde1b5.jpg";